<template>
  <form class="form" method="post">

    <div id="appCollectionVueComponent" class="appFontBlack">
      <HeaderApp />
      <div class="AppCollectionSelect">
        <h2>Choisir mon client ({{ client.length }})</h2>
      </div>
      <input type="text" v-model="search" class="appSearchBar" placeholder="Rechercher">
      <div :key="index" v-for="(client, index) in filteredClients" class="appClientCardList appHoverEffect">
        <div @click.prevent="selectClient(client._id)" class="appClientCardListSelect">
          <div class="appClientCardListLine1">
            <p>{{ client.firstname.toUpperCase() }} {{ client.lastname }}</p>
            <p>{{ format_date(client.birthdate) }}</p>
            <p>{{ client.sexe }}</p>
          </div>
        </div>
      </div>
    </div>

  </form>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import HeaderApp from '../Application/HeaderApp.vue'
export default {
  beforeCreate () {
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    if (!tokenWithDatas) { this.$router.push('/App/Login') }
  },
  components: {
    HeaderApp
  },
  name: 'ClientsCollectionList',
  data () {
    return {
      client: '',
      search: ''
    }
  },
  computed: {
    filteredClients () {
      if (this.client.length > 0) {
        return this.client.filter(client => {
          return client.firstname.toLowerCase().includes(this.search.toLowerCase()) ||
          client.lastname.toLowerCase().includes(this.search.toLowerCase())
        })
      }
    }
  },
  mounted () {
    this.listClient()
  },
  methods: {
    format_date (value) {
      if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
      }
    },
    listClient () {
      const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
      axios
        .get(('https://privilegia.fr/api/clients'), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
        .then((response) => {
          this.client = response.data.sort(function tri (a, b) {
            if (a.firstname < b.firstname) { return -1 }
            if (a.firstname === b.firstname) { return 0 }
            if (a.firstname > b.firstname) { return 1 }
          })
        })
    },
    selectClient (id) {
      this.$router.push('/App/Collection/Slot?id=' + id)
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Application/AppCollectionSelect.vue